import Lightbox from './utils/lightbox';

document.addEventListener('DOMContentLoaded', function () {
  // Reusable lightbox for clase gallery anchors
  new Lightbox({
    triggerSelector: 'a[data-clase-gallery]',
    modalId: 'clase-lightbox',
    template: '<div class="lightbox__inner lightbox__inner--clase"><button class="lightbox__close">×</button><img class="lightbox__img" src="" alt=""/></div>',
    attribute: 'href',
    closeSelector: '.lightbox__close',
    groupAttribute: 'data-clase-gallery',
  });

  // Transform FAQ rendered markup: ensure <details>/<summary> interaction is native
  // If you want animated accordion, handle in CSS or separate script in frontend project.
  // Nothing else required here since server outputs <details> already.
});
